var map = {
	"./alcohol.svg": "d1a7",
	"./alcohol_free.svg": "d592",
	"./celery.svg": "830d",
	"./chef_recommended.svg": "fe15",
	"./clams.svg": "5799",
	"./dairy.svg": "9ac5",
	"./dairy_free.svg": "16d4",
	"./egg.svg": "1e5f",
	"./fish.svg": "dcc2",
	"./gluten.svg": "83e2",
	"./gluten_free.svg": "53ff",
	"./halal.svg": "fffb",
	"./lupin.svg": "3f64",
	"./mustard.svg": "aba4",
	"./peanuts.svg": "663b",
	"./pork.svg": "6501",
	"./sesame.svg": "ba11",
	"./sesame_seeds.svg": "7569",
	"./shellfish.svg": "d488",
	"./soy_beans.svg": "7963",
	"./spicy.svg": "08d3",
	"./spicy_level_three.svg": "3766",
	"./spicy_level_two.svg": "438f",
	"./sulfites.svg": "f4f4",
	"./sustainable_fishing.svg": "933e",
	"./twenty_four_hours.svg": "418c",
	"./vegan.svg": "82e7",
	"./vegetarian.svg": "048d",
	"./walnuts.svg": "043b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "853f";